// 인형 질감 머티리얼: 무광에 부드러운 테두리 빛.
// fade를 켜면 카메라 바로 앞(6.5 이내)에서 디더로 사라져 카피바라를 가리지 않는다.
// three 0.169에서도 셰이더 조각 이름(emissivemap_fragment, clipping_planes_fragment)과
// 변수(normal, vViewPosition, totalEmissiveRadiance)는 r128과 같다.
import * as THREE from 'three';

/** 공유 uniform: 내 카피바라의 화면 위치·거리·반지름. camera.ts가 매 프레임 갱신한다. */
export const occlusion = {
  scr: { value: new THREE.Vector2(-9999, -9999) },
  depth: { value: 0 },
  rad: { value: 100 },
};

export function plush(color: THREE.ColorRepresentation, rimColor?: THREE.ColorRepresentation, rimStrength?: number, fade?: boolean): THREE.MeshStandardMaterial {
  const m = new THREE.MeshStandardMaterial({ color, roughness: 1, metalness: 0 });
  m.customProgramCacheKey = () => (fade ? 'plush-fade' : 'plush');
  const rim = { value: new THREE.Color(rimColor ?? color) };
  const strength = { value: rimStrength == null ? 0.35 : rimStrength };
  m.userData.rim = rim;
  m.userData.rimStrength = strength;
  m.onBeforeCompile = (shader) => {
    shader.uniforms.rimColor = rim;
    shader.uniforms.rimStrength = strength;
    shader.fragmentShader = 'uniform vec3 rimColor;\nuniform float rimStrength;\n' +
      shader.fragmentShader.replace('#include <emissivemap_fragment>',
        '#include <emissivemap_fragment>\n totalEmissiveRadiance += rimColor * rimStrength * pow(1.0 - saturate(dot(normal, normalize(vViewPosition))), 2.2);');
    if (fade) {
      shader.uniforms.uOcclScr = occlusion.scr;
      shader.uniforms.uOcclDepth = occlusion.depth;
      shader.uniforms.uOcclRad = occlusion.rad;
      shader.fragmentShader = 'uniform vec2 uOcclScr;\nuniform float uOcclDepth;\nuniform float uOcclRad;\n' +
        shader.fragmentShader.replace('#include <clipping_planes_fragment>',
          '#include <clipping_planes_fragment>\n float camD = length(vViewPosition); float dth = fract(sin(dot(floor(gl_FragCoord.xy), vec2(12.9898, 78.233)))*43758.5453);' +
          ' if (camD < 6.5){ float th = clamp((camD - 3.0)/3.5, 0.0, 1.0); if (dth > th) discard; }');
    }
  };
  return m;
}

const smoothCache: Record<string, THREE.MeshStandardMaterial> = {};

/** 소품용: 흰 테두리 빛을 아주 약하게 넣은 plush. 색마다 하나를 공유한다. */
export const smooth = (c: string): THREE.MeshStandardMaterial => (smoothCache[c] ||= plush(c, '#FFFFFF', 0.08));
